
import { Vue, Component, Prop, PropSync } from "vue-property-decorator";

@Component
export default class FilterableTransactionDetail extends Vue {
  @PropSync("showFilter", { type: Boolean })
  showFilterSync!: boolean;

  @PropSync("pinFilterDrawer", { type: Boolean })
  pinFilterDrawerSync!: boolean;

  @Prop({ required: false, default: false })
  isLoading!: boolean;

  /** The provided filter component will handle padding if set to false */
  @Prop({ required: false, default: true })
  filterContainer!: boolean;

  private applyFilterClick(): void {
    this.$parent?.$emit("filterable-transaction-detail-filter-apply-click");
    if (!this.pinFilterDrawerSync) this.showFilterSync = false;
  }

  private cancelFilterClick(): void {
    this.$parent?.$emit("filterable-transaction-detail-filter-cancel-click");
    if (!this.pinFilterDrawerSync) this.showFilterSync = false;
  }

  private closeFilterDrawer(): void {
    if (!this.pinFilterDrawerSync) {
      this.showFilterSync = false;
    }
  }
}
